import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { firstValueFrom } from 'rxjs'
import { filter, take } from 'rxjs/operators'

import { AuthenticationService } from '../authentication.service'

@Injectable()
export class RouteGuard implements CanActivate {
    private router = inject(Router)
    private authService = inject(AuthenticationService)

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // Wait for authentication to be initialized
        if (!this.authService.isInitialized()) {
            // Wait for initialization to complete
            await firstValueFrom(
                this.authService.isInitialized$.pipe(
                    filter(initialized => initialized),
                    take(1),
                ),
            )
        }

        const feature = route.data['feature']
        if (feature != null) {
            const hasFeature = this.authService.hasFeature(feature)
            if (hasFeature) {
                return hasFeature
            } else {
                this.authService.requestedRoute = state.url
                this.router.navigate(['signin'])
                return false
            }
        }

        // If we didn't specify a feature when we defined the route, assume we can always route to it.
        return true
    }
}
